import { useMemo } from 'react';

import type { Notification } from '@frontend/api/src/notifications/types';
import { HStack, UserGroupBadge } from '@frontend/legacy-components';
import { useDateFormat } from '@frontend/utils';

import { useUserGroupBadgeLookup } from 'utils/multisite';
import { capitalize } from 'utils/stringUtils';

import NotificationDate from './NotificationDate';

const NotificationDateAndBusinessName = ({
  notification,
}: {
  notification: Notification;
}) => {
  const { generateRelativeDateTime } = useDateFormat();

  const getBadgeProps = useUserGroupBadgeLookup();
  const badgeProps = getBadgeProps(notification.group.id);

  const { eventTime } = notification;

  const relativeDate = useMemo(
    () => eventTime && capitalize(generateRelativeDateTime(eventTime)),
    [generateRelativeDateTime, eventTime],
  );

  return (
    <HStack spacing={0.5} marginTop={0.5} minWidth={0} flexWrap="wrap">
      {badgeProps && (
        <UserGroupBadge
          size="sm"
          maxWidth="100%"
          name={badgeProps.name}
          colorPalette={badgeProps.colorPalette}
          icon={badgeProps.icon}
        />
      )}
      {relativeDate && <NotificationDate date={relativeDate} />}
    </HStack>
  );
};

export default NotificationDateAndBusinessName;
